import React from "react";
import { Container } from "react-bootstrap";
import styles from "./header.module.scss";
const Header = () => {
  return <Container className={styles.header}></Container>;
};

export default Header;
